import { downloadByLinkCreation } from './downloadByLinkCreation';

const formatISODateToDefault = (date: string | undefined) =>
  date ? date.split('T', 1)[0].replace('/', '-') : '';

const escapeCSV = (value) => {
  if (value == null) return '';
  let str = String(value);
  if (/[",\n]/.test(value)) {
    str = `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const convertLicensesToCSVDefault = (data: any, partnerId: string) => {
  let str =
    'SEN, Product, Organization, Main Contact, Start Date, End Date, Last Transaction Date, Entitlement Id, Entitlement Number\r\n';

  data.forEach((item) => {
    const isMainContact = item.partnerId?.toString() === partnerId;
    const mainContact = isMainContact ? item.mainContactEmail : '';

    const startDate = isMainContact ? formatISODateToDefault(item.startDate) : '';
    const endDate = isMainContact ? formatISODateToDefault(item.expireDate) : '';
    const lastTransactionDate = isMainContact
      ? formatISODateToDefault(item.lastTransactionDate)
      : '';
    const ccpEntitlementId = item.ccpEntitlementId || '';
    const slug = item.slug || '';

    const csvRow = `${item.accountId},${item.productDescription},${item.accountName},${mainContact},${startDate},${endDate},${lastTransactionDate},${ccpEntitlementId},${slug}`;
    str += `${csvRow}\r\n`;
  });
  return str;
};

const convertLicencesToCSVMigration = (data: any) => {
  let str =
    'organisation, sen, name, site_or_org_id, main_technical_contact, product_sen, product, migration_date, entitlement_id, entitlement_number\r\n';

  data.forEach((item) => {
    const sen = item.parentAccountId || '';
    const migrationDate = formatISODateToDefault(item.migrationDate);
    const ccpEntitlementId = item.ccpEntitlementId || '';
    const slug = item.slug || '';

    const csvRow = `${item.mainContactOrganisationName},${sen},${item.accountName},${item.externalUuid},${item.mainContactEmail},${item.accountId},${item.productDescription},${migrationDate},${ccpEntitlementId},${slug}`;
    str += `${csvRow}\r\n`;
  });
  return str;
};

const convertProductOfferingKeyMappingToCSV = (data: any) => {
  let str =
    'old_product_key, old_external_sku_id, new_product_id, new_offering_id, description, vendor_name, publicly_available\n';

  data.forEach((item) => {
    const publiclyAvailable = item.publicly_available ? 'YES' : 'NO';

    const csvRow = `${escapeCSV(item.old_product_key)},${escapeCSV(
      item.old_external_sku_id,
    )},${escapeCSV(item.new_product_id)},${escapeCSV(item.new_offering_id)},${escapeCSV(
      item.description,
    )},${escapeCSV(item.vendor_name)},${publiclyAvailable}`;
    str += `${csvRow}\n`;
  });
  return str;
};

const downloadCSV = (csvData: any, filename: string) => {
  if (!csvData) return;

  const blob = new Blob([csvData], { type: 'text/csv' });
  const href = URL.createObjectURL(blob);
  const download = `${filename}.csv`;

  downloadByLinkCreation(href, download);
};

/**
 * Creates a link element with the file content as a base64 encoded string and the suggested filename.
 * Clicks the link to download the file and removes the link from the DOM.
 * @param response The response of fetched api.
 * @param isMigration The type of CSV to download.
 * @param partnerId The partner Id to check if it's main contact for CSV download.
 * @returns void
 */

export const downloadLicensesOverviewCSV = (
  response: any,
  isMigration: boolean,
  partnerId: string,
) => {
  if (!response) return;

  const convertToCSV = isMigration ? convertLicencesToCSVMigration : convertLicensesToCSVDefault;
  const filename = isMigration ? 'Migration overview' : 'Customer account overview';
  const csvData = convertToCSV(response, partnerId);
  downloadCSV(csvData, filename);
};

export const downloadProductOfferingKeyMappingsCSV = (response: any) => {
  if (!response) return;

  const csvData = convertProductOfferingKeyMappingToCSV(response);
  downloadCSV(csvData, 'product-offering-key-mappings');
};
